import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// récupérer les paramètres de payement d'un année scolaire
export const getPaymentSettingsByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/paymentSetting/year/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les paramètres de paiement d'un étudiant
export const getPaymentSettingsById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/paymentSetting/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

//  modifier les paramètres de payement d'une année
export const updatePaymentSettingsById = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/paymentSetting/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
